import { OPEN_FILE_PREVIEW_EXTENSIONS } from '@modules/aawz-drive/constants/Text.js'

// ── Date formatting ────────────────────────────────────────────────

const MONTH_NAMES_SHORT_PT = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
]

export const parseEmailDateParts = (dateStr) => {
  const parts = dateStr.match(/(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})/)
  if (!parts) return null
  return {
    day: Number.parseInt(parts[1], 10),
    month: Number.parseInt(parts[2], 10) - 1,
    year: Number.parseInt(parts[3], 10),
    timeStr: `${parts[4]}:${parts[5]}`,
  }
}

export const formatEmailDateLabel = ({ day, month, year, timeStr }, ref) => {
  const today = new Date(ref.getFullYear(), ref.getMonth(), ref.getDate())
  const emailDate = new Date(year, month, day)

  if (emailDate.getTime() === today.getTime()) return `Hoje às ${timeStr}`
  today.setDate(today.getDate() - 1)
  if (emailDate.getTime() === today.getTime()) return `Ontem às ${timeStr}`

  const dayPad = String(day).padStart(2, '0')
  const monthName = MONTH_NAMES_SHORT_PT[month]
  if (year !== ref.getFullYear())
    return `${dayPad}/${monthName} de ${year} às ${timeStr}`
  return `${dayPad}/${monthName} às ${timeStr}`
}

export const formatEmailDate = (dateStr, now) => {
  if (!dateStr) return '-'
  const parsed = parseEmailDateParts(dateStr)
  if (!parsed) return dateStr
  return formatEmailDateLabel(parsed, now || new Date())
}

// ── Sender parsing ─────────────────────────────────────────────────

export const parseSender = (remetente) => {
  if (!remetente) return { name: '', email: '' }
  const match = remetente.match(/^([^<]+)<([^>]+)>$/)
  if (match) return { name: match[1].trim(), email: match[2].trim() }
  return { name: remetente, email: remetente }
}

// ── Attachment helpers ──────────────────────────────────────────────

export const hasAttachments = (message) => {
  return !!(message.anexos && Object.keys(message.anexos).length > 0)
}

export const getThreadAttachments = (msg) => {
  return Object.values(msg.anexos || {})
}

export const getFileExtension = (filename) => {
  if (!filename || !filename.includes('.')) return ''
  return filename.split('.').pop().toLowerCase()
}

export const canPreview = (anexo) => {
  return OPEN_FILE_PREVIEW_EXTENSIONS.includes(getFileExtension(anexo.filename))
}

export const getEmailScope = (state, scope) => {
  if (!state.crmEmails || !state.crmEmails[scope]) return null
  return state.crmEmails[scope]
}

export const getEmailScopeOrEmpty = (state, scope) => {
  return (state.crmEmails && state.crmEmails[scope]) || {}
}

/**
 * Remove o tracking pixel do HTML de um email.
 * Usado ao renderizar emails enviados pelo próprio profissional, para evitar
 * falsos positivos no registro de abertura (o pixel dispararia ao abrir no CRM).
 */
export const stripTrackingPixel = (html) => {
  if (!html) return html
  return html.replaceAll(
    /<img[^>]*\/v3\/api\/aawz-crm\/crm-conversas\/pixel\/[^>]*>/gi,
    '',
  )
}
